import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6TimeSeriesEdit } from "./edit";
import { A6TimeSeriesNew } from "./new";
import { A6TimeSeriesTable } from "./table";

export default function A6TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6TimeSeriesEdit />} />
      <Route index element={<A6TimeSeriesTable />} />
      <Route path="/new" element={<A6TimeSeriesNew />} />
    </Routes>
  );
}
